import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["action", "children", "onClose", "className", "classes", "variant"],
  _excluded2 = ["icon", "closeButton", "variantError", "variantSuccess"];
import { Grid, IconButton, SnackbarContent as MuiSnackbarContent } from '@material-ui/core';
import { CheckCircle, Close, Error } from '@material-ui/icons';
import { makeStyles } from '@material-ui/styles';
import { clsx } from 'clsx';
import { forwardRef } from 'react';
import styled from 'styled-components';
import { ColorDynamic } from "../theme/Color.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var PaddedContent = /*#__PURE__*/styled.span.withConfig({
  displayName: "SnackbarContent__PaddedContent",
  componentId: "SD__sc-1jca4d5-0"
})(["padding:2px 0 0;"]);
var useStyles = /*#__PURE__*/makeStyles(theme => ({
  root: {
    color: ColorDynamic.White,
    backgroundColor: ColorDynamic.Dark500,
    alignItems: 'flex-start',
    padding: '10px 16px',
    [theme.breakpoints.up('md')]: {
      width: 'auto',
      maxWidth: '512px',
      minWidth: '432px'
    }
  },
  action: {
    paddingLeft: theme.spacing(1)
  },
  message: {
    alignItems: 'flex-start',
    [theme.breakpoints.down('xs')]: {
      fontSize: theme.spacing(2)
    }
  },
  icon: {
    marginRight: theme.spacing(1),
    fontSize: theme.spacing(3)
  },
  closeButton: {
    color: ColorDynamic.White40,
    '&:hover, &:focus': {
      backgroundColor: ColorDynamic.White08,
      color: ColorDynamic.White40
    }
  },
  variantError: {
    color: ColorDynamic.Red500,
    background: ColorDynamic.Red50,
    '& $closeButton': {
      color: ColorDynamic.Red500
    }
  },
  variantSuccess: {}
}), {
  name: 'SD-SnackbarContent'
});
export var SnackbarContent = /*#__PURE__*/forwardRef((_ref, ref) => {
  var {
      action,
      children,
      onClose,
      className,
      classes,
      variant = 'default'
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useStyles = useStyles({
      classes
    }),
    {
      icon,
      closeButton,
      variantError,
      variantSuccess
    } = _useStyles,
    styles = _objectWithoutProperties(_useStyles, _excluded2);
  var Icon = variant === 'error' ? Error : variant === 'success' ? CheckCircle : undefined;
  return /*#__PURE__*/_jsx(MuiSnackbarContent, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    classes: styles,
    className: clsx(className, {
      [variantError]: variant === 'error',
      [variantSuccess]: variant === 'success'
    }),
    message: /*#__PURE__*/_jsxs(_Fragment, {
      children: [Icon && /*#__PURE__*/_jsx(Icon, {
        className: icon
      }), /*#__PURE__*/_jsx(PaddedContent, {
        children: children
      })]
    }),
    action: !action && !onClose ? null : /*#__PURE__*/_jsxs(Grid, {
      container: true,
      spacing: 1,
      alignItems: "center",
      wrap: "nowrap",
      children: [!!action && /*#__PURE__*/_jsx(Grid, {
        item: true,
        children: action
      }), onClose && /*#__PURE__*/_jsx(Grid, {
        item: true,
        children: /*#__PURE__*/_jsx(IconButton, {
          "aria-label": "close",
          onClick: onClose,
          className: closeButton,
          children: /*#__PURE__*/_jsx(Close, {
            fontSize: "small"
          })
        })
      })]
    })
  }));
});
if (process.env.NODE_ENV !== "production") SnackbarContent.displayName = "SnackbarContent";